import {getEndpoint, getHeaders} from "../../../helpers/endpoint";

export const REQUEST_FETCH_STATS_NEW_USERS_FUNNEL = 'REQUEST_FETCH_STATS_NEW_USERS_FUNNEL';
export const SUCCESS_FETCH_STATS_NEW_USERS_FUNNEL = 'SUCCESS_FETCH_STATS_NEW_USERS_FUNNEL';
export const FAIL_FETCH_STATS_NEW_USERS_FUNNEL = 'FAIL_FETCH_STATS_NEW_USERS_FUNNEL';

export const fetchStatsNewUsersFunnel = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_NEW_USERS_FUNNEL, payload });
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('fetchStatsNewUsersFunnel', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({ type: FAIL_FETCH_STATS_NEW_USERS_FUNNEL });
            else dispatch({ type: SUCCESS_FETCH_STATS_NEW_USERS_FUNNEL, data });

            if (onSuccess) onSuccess(data, payload);
        })
            .catch((error, type = FAIL_FETCH_STATS_NEW_USERS_FUNNEL) => {
                if (onFail) onFail(type, error);
                dispatch({ type, error });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/newUsersFunnel.js